import { useQuery, useMutation, useQueryClient } from 'react-query';
import { UserHttpService } from 'core/services/user';

const useLanguages = (cvId = null) => {
    const queryClient = useQueryClient();

    // Query for fetching languages
    const { data, isLoading, error } = useQuery(['languages', cvId], async () => {
        const response = await UserHttpService.listLanguages(cvId);
        return response.results || [];
    });

    // Mutation for adding a language
    const addLanguageMutation = useMutation(
        async (newLanguage) => {
            const languageData = {
                title: newLanguage.title,
                proficiency: newLanguage.proficiency
            };
            return await UserHttpService.createLanguage(languageData);
        },
        {
            onSuccess: () => {
                // Invalidate and refetch languages query
                queryClient.invalidateQueries(['languages', cvId]);
            }
        }
    );

    // Mutation for updating a language
    const updateLanguageMutation = useMutation(
        async (updatedLanguage) => {
            const languageData = {
                title: updatedLanguage.title,
                proficiency: updatedLanguage.proficiency
            };
            return await UserHttpService.updateLanguage(updatedLanguage.id, languageData);
        },
        {
            onSuccess: () => {
                // Invalidate and refetch languages query
                queryClient.invalidateQueries(['languages', cvId]);
            }
        }
    );

    // Mutation for deleting a language
    const deleteLanguageMutation = useMutation(
        async (id) => {
            return await UserHttpService.deleteLanguage(id);
        },
        {
            onSuccess: () => {
                // Invalidate and refetch languages query
                queryClient.invalidateQueries(['languages', cvId]);
            }
        }
    );

    return {
        languages: data || [],
        isLoading,
        error: error ? error.message : null,
        addLanguage: addLanguageMutation.mutateAsync,
        updateLanguage: updateLanguageMutation.mutateAsync,
        deleteLanguage: deleteLanguageMutation.mutateAsync
    };
};

export default useLanguages; 